import { IInitiative } from "@shared-base/generic-clases.base";

export const enum EStatusInitiatives
{
  Initial = "Inicial",
  InProcess = "InProcess",
  Finished = "Finished"
}

export const enum EInitiatives
{
  default = 'default',
  IncMty2026 = 'incMTY2026',
  TVMX = "TVMX"
}

export const Initiatives: IInitiative[] = [
  {
    id: EInitiatives.default,
    value: 'TVMX',
    label: 'TVMX',
    title: `<div class="d-none d-lg-flex align-items-center justify-content-center">
          <img style="width: 100%; max-width: 600px;" src="@1/images/initiatives/tvmx/bannerSitioWeb_@2.webp" />
        </div>
        <img style="width: 100%" class="d-block d-lg-none" src="@3/images/initiatives/tvmx/bannerSitioWeb_@4.webp">`,
    subtitle: '',
    bgClass: 'bg-tvmx-hero',
    textClass: 'text-white',
    imgBannerUrl: '/images/initiatives/tvmx/bannerSitioWebLupita1.svg',
    altImgBanner: 'Tv MX banner',
    termsConditions: "/pdf/Terminos_y_Condiciones_TVMX2026.pdf"
  },
  {
    id: EInitiatives.TVMX,
    value: 'TVMX',
    label: 'TVMX',
    title: `<div class="d-none d-lg-flex align-items-center justify-content-center">
          <img style="width: 100%; max-width: 600px;" src="@1/images/initiatives/tvmx/bannerSitioWeb_@2.webp" />
        </div>
        <img style="width: 100%" class="d-block d-lg-none" src="@3/images/initiatives/tvmx/bannerSitioWeb_@4.webp">`,
    subtitle: '',
    bgClass: 'bg-tvmx-hero',
    textClass: 'text-white',
    imgBannerUrl: '/images/initiatives/tvmx/bannerSitioWebLupita1.svg',
    altImgBanner: 'Tv MX banner',
    termsConditions: "/pdf/Terminos_y_Condiciones_TVMX2026.pdf"
  }
];
